import { Link } from "react-router-dom";
import SEO from "@/components/site/SEO";
import LegalShell from "@/components/site/LegalShell";

export default function Terms() {
  return (
    <LegalShell
      title="Terms and Conditions"
      lastUpdated="January 1, 2026"
      pageTestId="terms-page"
      seo={
        <SEO
          title="Terms and Conditions"
          description="OneDial Africa Terms and Conditions — the agreement between you and Scitygate Telecom UK Ltd when using our telecom and fintech services."
          path="/terms-and-conditions"
        />
      }
    >
      <p>
        These Terms and Conditions (“<strong>Terms</strong>”) govern your access to and use
        of the OneDial Africa website, mobile application and related services
        (collectively, the “Services”). OneDial Africa is a trading name of <strong>Scitygate Telecom UK Ltd</strong>,
        registered in England &amp; Wales under company number <strong data-testid="terms-company-number">16468736</strong>,
        with its registered office at 2nd Floor, Halifax House, 93–101 Bridge Street, Manchester M3 2GX, United Kingdom (“we”, “us”, “our”).
      </p>
      <p>By creating an account or using the Services you agree to be bound by these Terms.</p>

      <h2>1. Eligibility</h2>
      <p>You must be at least 18 years old and capable of entering into a binding contract to use the Services. By using the Services, you represent and warrant that you meet these requirements.</p>

      <h2>2. Your account</h2>
      <p>You are responsible for maintaining the confidentiality of your credentials and for all activities that occur under your account. Notify us immediately at <a href="mailto:support@onedialafrica.com" className="underline">support@onedialafrica.com</a> if you suspect unauthorised use.</p>

      <h2>3. Services</h2>
      <p>The Services include international calling, VoIP, video calling, messaging, calling cards, airtime top-up, data bundles, eSIM, digital wallet, money transfer, bill payments and business accounts. Specific features may be subject to additional terms presented in-app.</p>

      <h2>4. Fees, billing and refunds</h2>
      <ul>
        <li>Calling is billed per-second after the first second, unless otherwise stated.</li>
        <li>Money transfers and bill payments display the total cost, exchange rate and any fees before you confirm.</li>
        <li>Unused wallet balances remain yours and may be refunded subject to identity verification and applicable law.</li>
        <li>Completed transfers are generally non-reversible; please verify all details before confirming.</li>
      </ul>
      <p>
        Full details — including the 14-day cancellation right for unused top-ups, how to
        request a refund and how disputes are handled — are set out in our{" "}
        <Link to="/refund-policy" className="underline">Refund Policy</Link>,
        which forms part of these Terms.
      </p>

      <h2>5. Acceptable use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the Services for any unlawful, fraudulent, defamatory or harmful purpose.</li>
        <li>Interfere with or attempt to gain unauthorised access to any part of the Services.</li>
        <li>Resell, rent or commercially exploit the Services without our written permission.</li>
        <li>Upload or transmit malware, spam or any content that infringes third-party rights.</li>
      </ul>

      <h2>6. Compliance and verification</h2>
      <p>To comply with anti-money-laundering, counter-terrorist-financing and sanctions laws, we may verify your identity, source of funds and transactions. We may delay, suspend or refuse transactions or accounts where required by law.</p>

      <h2>7. Third-party services</h2>
      <p>Certain features depend on third-party providers (e.g., mobile network operators, banks, card networks). We are not responsible for the acts or omissions of third parties and your use of their services may be subject to their terms.</p>

      <h2>8. Intellectual property</h2>
      <p>All intellectual property in the Services is and remains owned by Scitygate Telecom UK Ltd or its licensors. You are granted a limited, non-exclusive, non-transferable licence to use the Services for personal or internal business purposes.</p>

      <h2>9. Disclaimers</h2>
      <p>The Services are provided on an “as is” and “as available” basis. To the maximum extent permitted by law, we disclaim all warranties, express or implied, including merchantability, fitness for a particular purpose and non-infringement.</p>

      <h2>10. Limitation of liability</h2>
      <p>To the fullest extent permitted by law, our aggregate liability arising out of or in connection with the Services shall not exceed the greater of (a) £100 or (b) the fees paid by you in the twelve (12) months preceding the event giving rise to the claim. We shall not be liable for any indirect, incidental, special or consequential damages.</p>

      <h2>11. Suspension and termination</h2>
      <p>We may suspend or terminate your access to the Services at any time, with or without notice, if you breach these Terms or if required by law. You may close your account at any time using the in-app account deletion option or by contacting support.</p>

      <h2>12. Changes to the Terms</h2>
      <p>We may update these Terms from time to time. Material changes will be notified in the app or by email. Continued use of the Services after changes take effect constitutes acceptance.</p>

      <h2>13. Governing law and disputes</h2>
      <p>These Terms are governed by the laws of England and Wales. The courts of England and Wales have exclusive jurisdiction over any disputes, subject to your mandatory consumer rights.</p>

      <h2>14. Contact</h2>
      <p>
        Scitygate Telecom UK Ltd<br />
        2nd Floor, Halifax House, 93–101 Bridge Street, Manchester M3 2GX, United Kingdom<br />
        Registered in England &amp; Wales · Company No. 16468736<br />
        Telephone: 0161 989 4842<br />
        Email: <a href="mailto:support@onedialafrica.com" className="underline">support@onedialafrica.com</a>
      </p>
    </LegalShell>
  );
}
